var _path, _path2, _path3;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgIl({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 512.001 512.001",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M503.172 423.725H8.828A8.829 8.829 0 0 1 0 414.897V97.104a8.829 8.829 0 0 1 8.828-8.828h494.345a8.829 8.829 0 0 1 8.828 8.828v317.793a8.83 8.83 0 0 1-8.829 8.828z",
    fill: "#41479b"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fill: "#f5f5f5",
    d: "M0 150.071h512v211.86H0z"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M301.869 256.001l22.933-39.721h-45.865L256 176.553l-22.936 39.727h-45.865l22.933 39.721-22.933 39.721h45.865L256 335.449l22.936-39.727h45.865l-22.932-39.721zm.433-26.73l-7.933 13.74-7.933-13.74h15.866zm-15.433 26.73l-15.433 26.73h-30.873l-15.432-26.73 15.433-26.73h30.873l15.432 26.73zM256 202.535l7.936 13.746h-15.872L256 202.535zm-46.302 26.736h15.865l-7.933 13.74-7.932-13.74zm0 53.46l7.933-13.74 7.933 13.74h-15.866zM256 309.467l-7.936-13.746h15.872L256 309.467zm38.369-40.476l7.933 13.74h-15.865l7.932-13.74z",
    fill: "#41479b"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIl);
export default __webpack_public_path__ + "static/media/il.3040e090e02e86e0b11d2038def9898d.svg";
export { ForwardRef as ReactComponent };